import { FaEye } from "react-icons/fa";
import { formatDateDDMMYY } from "../../../../utils/dateUtils";

import "./index.scss";

const CertificateTable = ({ data, onViewDetails }) => {
  if (!data || data.length === 0) return null;

  return (
    <table className="certificate-table">
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Customer Name</th>
          <th>IMEI No</th>
          <th>Plan Name</th>
          <th>Client Name</th>
          <th>Policy start date</th>
          <th>Policy end date</th>
          <th>View More</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td>{index + 1}.</td>
            <td>{item?.customer_Name}</td>
            <td>{item?.imeI_No}</td>
            <td>{item?.plan_Name}</td>
            <td>{item?.client_Name}</td>
            <td>{formatDateDDMMYY(item?.policy_Start_Date)}</td>
            <td>{formatDateDDMMYY(item?.policy_End_Date)}</td>
            <td>
              <button
                className="certificate-table__view-btn"
                onClick={() => onViewDetails(item)}
              >
                <FaEye />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CertificateTable;
